import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNotify } from '~/hooks/useNotify'

type CopyToClipboardOptions = {
  notificationText?: string
  silent?: boolean
}

export const useCopyToClipboard = () => {
  const { t } = useTranslation()
  const notify = useNotify()

  return React.useCallback(
    (
      text: string,
      { notificationText = t('copied'), silent }: CopyToClipboardOptions = {},
    ) => {
      navigator.clipboard.writeText(text)

      if (!silent) {
        notify({ content: notificationText, style: 'info' })
      }
    },
    [notify, t],
  )
}

export type CopyToClipboard = ReturnType<typeof useCopyToClipboard>
